import { render, staticRenderFns } from "./ReferralDutyConsultationImportModal.vue?vue&type=template&id=db1c5e1a&scoped=true"
import script from "./ReferralDutyConsultationImportModal.vue?vue&type=script&lang=js"
export * from "./ReferralDutyConsultationImportModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralDutyConsultationImportModal.vue?vue&type=style&index=0&id=db1c5e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1c5e1a",
  null
  
)

export default component.exports